import { ApiClient } from '../../../../infra';
import { fromBackend } from '../../../../domain';
/**
 * O que o Relatorio de Sono pede ao servidor.
 *
 * O relatorio em si, e as SELECOES de atletas - que sao salvas no servidor
 * justamente para nao viajarem no endereco: vinte e um ids numa URL seriam
 * ilegiveis, e a selecao se repete semana apos semana.
 */
export class SleepReportApi {
    constructor() {
        this.client = ApiClient.INSTANCE;
    }
    static { this.INSTANCE = new SleepReportApi(); }
    /**
     * @param companyId a empresa em escopo. Desde 18/09/2026 o servidor a exige de quem
     *                  administra mais de uma, e recusa em vez de escolher por conta
     *                  propria - um relatorio da empresa errada e pior que nenhum.
     */
    async fetchSleepReport(patientIds, range, companyId, signal) {
        if (patientIds.length === 0) {
            return [];
        }
        const body = { ...range, patientIds, companyId };
        const nights = (await this.client.send('POST', '/v2/dashboard/sleep-report', body, signal));
        // A noite e do dia em que a pessoa deitou, no fuso de quem olha - e o mesmo dia que o
        // servidor usou para recortar o intervalo.
        return nights.map((night) => ({
            ...night,
            bedtime: fromBackend(night.bedtime),
            wakeup: fromBackend(night.wakeup)
        }));
    }
    /**
     * As selecoes salvas de quem esta logado.
     *
     * O servidor nunca recebe o dono: ele o le da sessao. Por isso nao ha parametro
     * aqui, e por isso a selecao de outra pessoa simplesmente nao existe.
     */
    /**
     * Os elencos salvos NESTA empresa.
     *
     * O elenco de um cliente nao e o do outro: sem a empresa, o "todos" de uma
     * aparecia no seletor da outra, e aplica-lo pedia ao servidor os atletas da empresa
     * anterior. As selecoes criadas antes de a empresa existir vem junto em qualquer
     * uma - elas sao do dono, e nao ha de onde deduzir a empresa delas.
     */
    async fetchPatientSelections(companyId) {
        const escopo = companyId === undefined ? '' : `?companyId=${companyId}`;
        return (await this.client.send('GET', `/v2/patient-selections${escopo}`));
    }
    async createPatientSelection(name, patientIds, companyId) {
        return (await this.client.send('POST', '/v2/patient-selections', {
            name,
            patientIds,
            companyId: companyId ?? null
        }));
    }
    async updatePatientSelection(id, name, patientIds) {
        return (await this.client.send('PUT', `/v2/patient-selections/${id}`, { name, patientIds }));
    }
    async deletePatientSelection(id) {
        await this.client.send('DELETE', `/v2/patient-selections/${id}`);
    }
}
//# sourceMappingURL=sleep-report.api.js.map